import { generatePath, useNavigate } from 'react-router-dom'
import { ChangeManagementCourse } from '@/assets/icons/change-management-course'
import { DocumentFileIcon } from '@/assets/icons/document-file-icon'
import { TransferIcon } from '@/assets/icons/transfer-icon'
import { Card } from '@/components/cards/student-card'
import { StudentRequestCard } from '@/components/cards/student-request-card'
import { StudentLayout } from '@/components/layout/student'
import { Button } from '@/components/ui/button'
import { REQUEST_TYPE } from '@/constants/request-type'
import { ROUTES } from '@/constants/routes'
import type { StudentRequest } from '@/types/student/student-request.type'
import { useStudentHome } from './hooks/use-student-home'

export const StudentHomePage = () => {
  const {
    states: { data, isPageLoading },
    actions: { verifyRequestEligibility }
  } = useStudentHome()
  const navigate = useNavigate()

  function handleExternalTransfer() {
    if (
      verifyRequestEligibility(
        REQUEST_TYPE.EXTERNAL_TRANSFER.id,
        REQUEST_TYPE.EXTERNAL_TRANSFER.name
      )
    ) {
      navigate(`/${ROUTES.STUDENT_EXTERNAL_TRANSFER.route}`)
    }
  }

  function handleChangeOfMajor() {
    navigate(`/${ROUTES.STUDENT_CHANGE_OF_MAJOR.route}`)
  }

  function handleCreditTransfer() {
    navigate(`/${ROUTES.STUDENT_CREDIT_TRANSFER.route}`)
  }

  function navigateToRequest(request: StudentRequest) {
    const path = generatePath(ROUTES.STUDENT_MY_REVIEWS.route, {
      id: request.id
    })
    navigate(`/${path}`)
  }

  return (
    <StudentLayout isLoading={isPageLoading} withLogoHeader={true}>
      <h1 className="text-2xl font-bold pb-6">Análises Curriculares</h1>
      <p className="text-md">
        O transfere fácil é a sua plataforma para solicitações de análises
        curriculares. Você veio de uma outra universidade/faculdade e quer
        aproveitar as disciplinas que já cursou? Ou você está realizando a sua
        segunda graduação e quer dispensar as disciplinas que já estudou? É aqui
        no transfere fácil que você resolve isso!
      </p>
      <div className="flex py-6 gap-8 justify-between">
        <Card
          variant="mdCard"
          title="Aproveitamento de Estudos"
          description={
            <>
              Processo em que <strong>o aluno Fatecie,</strong> solicita uma
              análise curricular para verificar{' '}
              <strong>
                quais disciplinas já cursadas e aprovadas de cursos anteriores
              </strong>{' '}
              (1ª graduação, graduação incompleta, etc) que podem ser
              aproveitadas.
            </>
          }
          icon={<DocumentFileIcon />}
        >
          <Button
            disabled
            onClick={handleCreditTransfer}
            className="w-2/3 text-md mt-1"
          >
            Solicitar Aproveitamento +
          </Button>
        </Card>
        <Card
          variant="mdCard"
          title="Troca de Curso"
          description={
            <>
              Processo em que <strong>o aluno Fatecie,</strong> solicita uma
              <strong> troca de curso dentro da mesma modalidade </strong>
              (EAD para EAD ou Presencial para Presencial) e verifica{' '}
              <strong>
                quais disciplinas podem ser aproveitadas do curso antigo para o
                novo curso.
              </strong>
            </>
          }
          icon={<ChangeManagementCourse />}
        >
          <Button
            disabled
            className="w-2/3 text-md mt-2"
            onClick={handleChangeOfMajor}
          >
            Solicitar Troca de Curso +
          </Button>
        </Card>
        <Card
          variant="mdCard"
          title="Transferência Externa"
          description={
            <>
              Processo em que o
              <strong> aluno, vindo de outra universidade,</strong> solicita uma
              análise curricular para verificar quais
              <strong> disciplinas podem ser aproveitadas,</strong> que já foram
              <strong> cursadas no curso da universidade anterior.</strong>
            </>
          }
          icon={<TransferIcon />}
        >
          <Button
            className="text-md w-2/3 mt-2"
            onClick={handleExternalTransfer}
          >
            Solicitar Transf. Externa +
          </Button>
        </Card>
      </div>
      <div>
        <h1 className="py-6 text-2xl font-bold">Suas Análises</h1>
        <p className="text-md">
          Acompanhe os status das suas solicitações por aqui:
        </p>
        <div className="grid grid-cols-5 place-items-center py-4 gap-3">
          {data?.map((request) => (
            <button
              key={request.id}
              onClick={() => navigateToRequest(request)}
              type="button"
              className="cursor-pointer"
            >
              <StudentRequestCard key={request.id} studentRequest={request} />
            </button>
          ))}
        </div>
      </div>
    </StudentLayout>
  )
}
